{
  "sections": {
    "title": {
      "stream": "Live view",
      "device": "Camera management",
      "user": "User management",
      "area": "Area management",
      "tag": "Tag management",
      "recording": "Recording playback",
      "clip": "Captures",
      "accountSettings": "Account settings",
      "companySettings": "Company settings",
      "firmware": "Firmware management",
      "patlite": "Signal tower color detection",
      "handsLicense": "Hands license management",
      "viewer": "Viewer",
      "samlLogin": "SSO sign-in",
      "login": "Sign in",
      "forgotPassword": "Forgot password",
      "resetPassword": "Reset password"
    },
    "title2": "Map management",
    "title3": "Create map",
    "title4": "Edit map"
  }
}
